import Vue from 'vue';

export default Vue.directive('app-button', {
  bind: (el, binding) => {
    const { size, color } = el.attributes;
    const { modifiers } = binding;

    el.className += ` app-button ${Object.keys(modifiers).join(' ')}`;

    el.className += ` ${(size || {}).value || ''}`;
    el.className += ` ${(color || {}).value || ''}`;
  },
});
